import { render, staticRenderFns } from "./StepDemandeur.vue?vue&type=template&id=2c2e48b2&scoped=true"
import script from "./StepDemandeur.vue?vue&type=script&lang=js"
export * from "./StepDemandeur.vue?vue&type=script&lang=js"
import style0 from "./StepDemandeur.vue?vue&type=style&index=0&id=2c2e48b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2e48b2",
  null
  
)

export default component.exports